export const QUOTE_STATUSES = [
  { value: "bozza", label: "Bozza / Da misurare", color: "#FEFCE8", text: "#854D0E" },
  { value: "sopralluogo_programmato", label: "Sopralluogo programmato", color: "#F0FDF4", text: "#166534" },
  { value: "sopralluogo_eseguito", label: "Sopralluogo eseguito", color: "#ECFDF5", text: "#047857" },
  { value: "preventivo_in_preparazione", label: "In preparazione", color: "#FEFCE8", text: "#854D0E" },
  { value: "inviato", label: "Inviato", color: "#FFF7ED", text: "#C2410C" },
  { value: "in_trattativa", label: "In forse / trattativa", color: "#F5F3FF", text: "#6B21A8" },
  { value: "accettato", label: "Accettato", color: "#F0FDF4", text: "#15803D" },
  { value: "rifiutato", label: "Rifiutato", color: "#FEF2F2", text: "#B91C1C" },
];

export const JOB_STATUSES = [
  { value: "sopralluogo", label: "Sopralluogo", color: "#F0FDF4", text: "#166534" },
  { value: "preventivo_da_fare", label: "Preventivo da fare", color: "#FEFCE8", text: "#854D0E" },
  { value: "preventivo_inviato", label: "Preventivo inviato", color: "#FFF7ED", text: "#C2410C" },
  { value: "confermato", label: "Confermato", color: "#F0FDF4", text: "#15803D" },
  { value: "materiale_ordinato", label: "Materiale ordinato", color: "#E0F2FE", text: "#0369A1" },
  { value: "materiale_pronto", label: "Materiale pronto", color: "#E0E7FF", text: "#3730A3" },
  { value: "montaggio_programmato", label: "Montaggio programmato", color: "#FAF5FF", text: "#7E22CE" },
  { value: "completato", label: "Completato", color: "#ECFDF5", text: "#065F46" },
];

export const REJECT_REASONS = [
  { value: "prezzo", label: "Prezzo" },
  { value: "tempi", label: "Tempi" },
  { value: "concorrente", label: "Concorrente" },
  { value: "lavoro_rimandato", label: "Lavoro rimandato" },
  { value: "altro", label: "Altro" },
  { value: "non_comunicato", label: "Non comunicato" },
];

export const ATTACH_CATEGORIES = [
  { value: "foto_sopralluogo", label: "Foto sopralluogo" },
  { value: "foglio_misure", label: "Foglio misure / preventivo" },
  { value: "foto_lavoro_finito", label: "Foto lavoro finito" },
  { value: "foglio_fine_lavori", label: "Foglio fine lavori" },
  { value: "documento", label: "Documento" },
];

export const APPT_TYPES = [
  { value: "sopralluogo", label: "Sopralluogo", color: "#0369A1" },
  { value: "montaggio", label: "Montaggio", color: "#C2593F" },
  { value: "preventivo", label: "Preventivo", color: "#7E22CE" },
];

// Google-Calendar-style fixed categories (mandatory colours)
export const CAL_CATEGORIES = [
  { key: "red", label: "Preventivi / Sopralluoghi", color: "#DC2626" },
  { key: "green", label: "Scadenze da pagare", color: "#16A34A" },
  { key: "yellow", label: "1ª squadra", color: "#CA8A04" },
  { key: "blue", label: "2ª squadra", color: "#2563EB" },
];
export const CAT_COLOR = { red: "#DC2626", green: "#16A34A", yellow: "#CA8A04", blue: "#2563EB", other: "#64748B" };

export function apptCategory(a, teamOrder = []) {
  if (a.category_id) return a.category_id;
  if (a.type === "sopralluogo" || a.type === "preventivo") return "red";
  const idx = teamOrder.indexOf(a.team_id);
  if (idx === 0) return "yellow";
  if (idx === 1) return "blue";
  return "yellow";
}

export function timeToMin(t) {
  if (!t) return 0;
  const [h, m] = t.split(":").map(Number);
  return (h || 0) * 60 + (m || 0);
}
export function minToTime(min) {
  min = Math.max(0, Math.min(24 * 60 - 1, Math.round(min)));
  const h = Math.floor(min / 60), m = min % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
}

export function statusMeta(list, value) {
  return list.find((s) => s.value === value) || { label: value, color: "#F1F5F9", text: "#334155" };
}

export function eur(n) {
  return "€ " + Number(n || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function itDate(d) {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return d; }
}
